// Lab codenames — internal aliases used only inside the fv.cli terminal
// theater. Keeps the backend stack opaque to anyone screenshotting the
// runtime log. Public model selector still shows the real brand names
// (FLUX 1.1 Pro etc.) — this is flavor, not real obfuscation. A dev
// tools inspector can still see the actual HTTP calls, so don't treat
// this as security — treat it as brand.

const PROVIDER_CODENAME: Record<string, string> = {
  hf: 'commons',
  replicate: 'northgate',
  'hf-endpoint': 'vault',
  'fal-ai': 'slipstream',
  'bfl-direct': 'origin',
  'hf-space': 'attic',
}

const MODEL_CODENAME: Record<string, string> = {
  'flux-schnell': 'sparrow',
  'flux-1-1-pro': 'monarch',
  'flux-1-1-pro-ultra': 'monarch-x',
  'flux-kontext-pro': 'echo',
  'flux-kontext-max': 'echo-x',
  'ideogram-v3': 'glyph-3',
  'recraft-v3': 'vector-3',
}

export function providerCodename(real: string): string {
  return PROVIDER_CODENAME[real] ?? real
}

// Model codenames — trained LoRAs get a deterministic "atelier-" handle
// derived from the first 8 chars of the dataset UUID so they're stable
// across sessions without leaking the real dataset id.
export function modelCodename(real: string): string {
  if (real.startsWith('lora:')) {
    const slug = real.slice(5, 13) || 'xxxxxxxx'
    return `atelier-${slug}`
  }
  return MODEL_CODENAME[real] ?? real
}

// Encoder codename — shown when streaming the preflight log. Keeps the
// real encoder name (t5-xxl) out of the log.
export const ENCODER_CODENAME = 'grammar-xxl'
